import {
  FETCH_SYNONYMS,
  receiveSynonyms,
  UPDATE_SYNONYMS,
} from "@/components/search/internal/ducks/Actions"
import { apiFetchSynonyms, apiUpdateSynonyms } from "@/components/search/internal/ducks/AJAX"

export default (store) => (next) => (action) => {
  const { dispatch } = store
  const receiveSynonymsSuccess = (cb) => (resp) => {
    dispatch(receiveSynonyms(resp))
    if (cb) {
      cb()
    }
  }

  switch (action.type) {
    case FETCH_SYNONYMS:
      apiFetchSynonyms(receiveSynonymsSuccess(action.success), action.error)
      return next(action)

    case UPDATE_SYNONYMS:
      apiUpdateSynonyms(action.params, receiveSynonymsSuccess(action.success), action.error)
      return next(action)

    default:
      return next(action)
  }
}
